export default __webpack_public_path__ + "static/media/standard_07.a8ee4a3c.png";